export default {
  methods: {
    scrollUP () {
      const ref = this.getActiveContainer();
      ref.scrollBy({
        top: -(window.screen.height / 3),
        left: 0,
        behavior: 'smooth'
      });
    },
    scrollDOWN () {
      const ref = this.getActiveContainer();
      ref.scrollBy({
        top: window.screen.height / 3,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
};
